import { RootState } from "../../Store";

export const selectNumberOfSavedItems = (state: RootState) => state.SavedItemsReducer.savedItemsArray.length;

export const selectSavedItems = (state: RootState) => state.SavedItemsReducer.savedItemsArray;
export const selectGetItemByIdRequestSuccess = (state: RootState) => state.SavedItemsReducer.getItemByIdRequestSuccess;
